import { useQuery } from '@tanstack/react-query'
import { ComboboxItem } from '@node-space/ui-components'
import { reactQueryKeys } from 'reactQueryKeys/reactQueryKeys'
import { getCountryStates } from 'services/CustomerService'
import { CountryState } from 'types/types'
import { ONE_DAY } from 'utils/utils'

export const useCountryStatesQuery = (countryCode: string, enabled = false) => {
  return useQuery({
    enabled: enabled && !!countryCode,
    queryKey: reactQueryKeys.countryStates(countryCode),
    queryFn: () => getCountryStates(countryCode),
    refetchOnMount: false,
    staleTime: ONE_DAY,
    select: (countryStates: CountryState[]): ComboboxItem[] => {
      return countryStates?.map(state => ({
        value: state?.code,
        leftText: state?.name,
      }))
    },
  })
}
